import { render } from "./MainMenuView.vue?vue&type=template&id=6b75024a&scoped=true"
import script from "./MainMenuView.vue?vue&type=script&lang=js"
export * from "./MainMenuView.vue?vue&type=script&lang=js"

import "./MainMenuView.vue?vue&type=style&index=0&id=6b75024a&scoped=true&lang=css"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b75024a"]])

export default __exports__